module.exports = __webpack_public_path__ + "img/quiz.863d51ba.svg";